import React from "react";
import Landing from "./Landing";

const DC = () => <Landing location="Washington, D.C." />;

export default DC;
